
import axiosClient from "./axiosClient";

const serviceUrl = '/qlkhambenh/phieu-chi-dinh';

const examinationService = {

  getListSpecifyTicket: async (id) => {
    const params = { id: id };
    const url = serviceUrl;
    const response = await axiosClient.get(serviceUrl, { params: params });
    return response;
  },
  getSpecifyTicket: async (params) => {
    const url = serviceUrl + `/get-by-id-phieu-kham-ngoai-tru`;
    const response = await axiosClient.get(url, { params: params });
    return response
  },
  deleteSpecifyTicket: async (id) => {
    const url = serviceUrl + `?id=${id}`;
    const response = await axiosClient.delete(url);
    return response
  },
  saveSpecifyTicket: async (params) => {
    const response = await axiosClient.post(serviceUrl, params);
    return response;
  },
  getLichSuPhong: async (idPhieuKham) => {
    const url = `/qlkhambenh/lich-su-phong/lich-su-lich-su-phong`;
    const params = { idPhieuKham: idPhieuKham }
    const response = await axiosClient.get(url, { params: params });
    return response.data
  },
  updateCheckboxTaiKham: async (maBenhNhan, checkBox) => {
    const url = `/qlkhambenh/benh-nhan/update-check-box?maBenhNhan=${maBenhNhan}&checkBox=${checkBox}`;
    const response = await axiosClient.put(url);
    return response.data
  },

  completeKCB: async (idPhieuKham) => {
    const url = `/qlkhambenh/phieu-kham/cap-nhat-trang-thai?id=${idPhieuKham}&trangThai=3`;
    const response = await axiosClient.put(url);
    return response.data;
  },
  deleteChiDinhTrongPhieu: async (params) => {
    const url = `/qlkhambenh/chi-dinh`;
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  getPhieuChiDinh: async (params) => {
    const url = `/qlkhambenh/phieu-chi-dinh`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },

  //Biểu đồ
  getChart: async (params) => {
    const url = `/qlkhambenh/phieu-kham/bao-cao-thoi-gian-cho-detail`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  //Xuất excel biểu đồ
  getExportChart: async (param) => {
    const url = `/qlkhambenh/phieu-kham/export-bao-cao-thoi-gian-cho-detail`;
    const response = await axiosClient.get(url, {
      params: param,
      responseType: "blob",
    });
    return response;
  },
};

export default examinationService;
